<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" style="margin-top: 20px;">
  <button routerLink="/industriepartner-neu" mat-raised-button color="primary" class="mb-1">
    Neue Industriepartner
  </button>
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        Alle Industriepartner-Masteraccounts
      </mat-card-title>
    </mat-card-header>
    <mat-card-content fxLayoutAlign="center" *ngIf="loading">
      <mat-spinner diameter="30" ></mat-spinner>
    </mat-card-content>
    <mat-card-content [hidden]="loading">
      <mat-form-field style="width: 100%;">
        <mat-label>
          Suche
        </mat-label>
        <input matInput [formControl]="search">
      </mat-form-field>

      <table mat-table [dataSource]="industriepartnerFiltered" matSort style="width: 100%;" [hidden]="industriepartnerFiltered.data.length == 0">
        <ng-container matColumnDef="kundennumm">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Kundennummer
          </th>
          <td mat-cell *matCellDef="let element"> {{element.kundennumm}} </td>
        </ng-container>

        <ng-container matColumnDef="anbieternummer">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Anbieternummer
          </th>
          <td mat-cell *matCellDef="let element"> {{element.anbieternummer}} </td>
        </ng-container>

        <ng-container matColumnDef="nama">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.nama}} </td>
        </ng-container>

        <ng-container matColumnDef="plz">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> PLZ </th>
          <td mat-cell *matCellDef="let element"> {{element.plz}} </td>
        </ng-container>

        <ng-container matColumnDef="ort">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Ort </th>J
          <td mat-cell *matCellDef="let element"> {{element.ort}} </td>
        </ng-container>

        <ng-container matColumnDef="strasse">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Straße </th>
          <td mat-cell *matCellDef="let element"> {{element.strasse}} </td>
        </ng-container>

        <ng-container matColumnDef="vorname">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Ansprechpartner </th>
          <td mat-cell *matCellDef="let element">{{element.vorname}} {{element.nachname}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element"> {{element.status}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['anbieternummer', 'kundennumm', 'nama', 'plz', 'ort', 'strasse', 'vorname', 'status']"></tr>
        <tr [routerLink]="'/industriepartner/'+row.anbieternummer" style="cursor: pointer;" class="row-hover" mat-row *matRowDef="let row; columns: ['anbieternummer', 'kundennumm', 'nama', 'plz', 'ort', 'strasse', 'vorname', 'status'];"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
